/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Description from "../Inputs/Description";
import Dropdown from "../Inputs/Dropdown";
import Amount from "../Inputs/Amount";
import Date from "../Inputs/Date";
import { AccountItem, BudgetItem, BucketTypeDefinitionItem, CurrentUser, DateTime, FamilyBucketLabel, FamilyFeatureValue, FamilyHasAccess, GetAllocationBucketNodeIds, GetAvailableBucketNodeOptions, GetEnabledBucketDefinitions, IsAllocationBucketSelectionValid, ReceiptEmailItem, RevalidateAllocationBucketNodes, SelectableItem, TransactionAllocation, TransactionItem, UpdateAllocationBucketNodeIds, USCurrency, UserItem, VisuallyHiddenInput } from "../../types";
import { useSelector } from "react-redux";
import { Backdrop, Button, CircularProgress, Grid } from "@mui/material";
import { BoxArrowInRight, BoxArrowInUp, CloudUploadFill, ExclamationCircleFill, Map, ReceiptCutoff } from "react-bootstrap-icons";
import FileResizer from "react-image-file-resizer";
import Divider from "../Inputs/Divider";
import InnerImageZoom from 'react-inner-image-zoom';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';
import MapView from "./MapView";
import { useFetch } from "../../features/Fetch/Fetch";
import { Features } from "../../constants";
import Toggle from "../Inputs/Toggle";
import DropdownMenu from "../Inputs/DropdownMenu";
import ImportQuickReceipt from "./ImportQuickReceipt";
import ImportManualEntry from "./ImportManualEntry";
import ModalHeader from "./ModalHeader";
import ModalFooterSaveCancel from "./ModalFooterSaveCancel";
import AmountWithTooltip from "../Inputs/AmountWithTooltip";
import { useItems } from "../../features/Fetch/Items";
import Q, { Deferred } from "q";
import AutoCompleteMerchant from "../Inputs/AutoCompleteMerchant";

const EditTransaction = (props: any) => {
	let repo = useItems();

	let [transaction, setTransaction] = useState(props.Transaction as TransactionItem);
	let transactions: TransactionItem[] = props.Transactions;
	let allTransactions = repo.SortedTransactions(null) ?? [] as TransactionItem[];
	let budgets: BudgetItem[] = CurrentBudgets(props.Budgets);
	let receiptEmails: ReceiptEmailItem[] = props.ReceiptEmails;
	let myBudgets = budgets.filter(b => b.isMine || b.budgetId < 1 || !b.requiresApproval);
	let users: UserItem[] = useSelector((state: any) => state.users.value);
	let accounts: AccountItem[] = useSelector((state: any) => state.accounts.value);
	let user: CurrentUser = useSelector((state: any) => state.userData.value);
	let bucketNodes = useSelector((state: any) => state.bucketNodes.value);
	let budgetLabel = FamilyBucketLabel(user, "budget", "Budget");
	let subBudgetLabel = FamilyBucketLabel(user, "subBudget", "SubBudget");
	let buckets = GetEnabledBucketDefinitions(user);
	let request = useFetch();

	useEffect(() => {
		if (props.AttachedReceipt) {
			LoadReceipts(true);
		}
	}, []);

	let PDFJS = require('pdfjs-dist/webpack');
	let [receiptOpen, setReceiptOpen] = useState(false);
	let [openQuickReceipt, setOpenQuickReceipt] = useState(false);

	let actualTotal: number | null = ActualTotal(transaction);
	if (actualTotal === 0) actualTotal = null;
	let [total, setTotal] = useState(actualTotal);
	let [imageChoice, setImageChoice] = useState(0);
	let [openImport, setOpenImport] = useState(false);
	let [setTaxes, setSetTaxes] = useState(transaction.rate == null || transaction.rate > 0);
	let [noTaxes, setNoTaxes] = useState(transaction.rate === 0);
	let [overlay, setOverlay] = useState(false);
	let [showReceipt, setShowReceipt] = useState(!transaction.hasReceipt);

	let isMiles = transaction.isMiles;
	let isMileSelection = imageChoice === 0;

	if (isMiles && isMileSelection && (transaction.accountTransactionId > 0)) {
		setImageChoice(2);
	}

	if (isMiles && isMileSelection && transaction.accountTransactionId === 0) {
		return (<>
			<ModalHeader Title={`${transaction.accountTransactionId > 0 ? 'Edit' : 'Add'} ${isMiles ? 'Mileage' : FamilyFeatureValue(user, Features.TransactionTitle)}`} CanDelete={props.OnDelete !== undefined} Close={props.Close} Delete={() => props.OnDelete(transaction)} />
			<div className="modal-body">
				<Grid container>
					<Button className="mx-3 right" component="label" variant="contained" startIcon={<Map />} onClick={() => setImageChoice(1)}>
						Use Map
					</Button>
					<Button className="mx-3 right" component="label" variant="contained" onClick={() => setImageChoice(2)}>
						Enter Manually
					</Button>
				</Grid>
			</div>
			<ModalFooterSaveCancel ShowSave={ShouldShowSave()} Save={() => props.OnSave(transaction)} Close={props.Close} />
		</>);
	}

	let fullyImportable = [] as TransactionItem[];
	if (transaction.isExternal) {
		let withinWeek = transactions.filter(t => !t.isExternal && Math.abs(t.transactionDate.dayDiff(transaction.transactionDate)) < 7);
		fullyImportable = withinWeek.filter(t => ActualTotal(t) === actualTotal);
	} else if (transaction.accountTransactionId > 0 && !props.Nested) {
		let withinWeek = transactions.filter(t => t.isExternal && Math.abs(t.transactionDate.dayDiff(transaction.transactionDate)) < 7);
		fullyImportable = withinWeek.filter(t => ActualTotal(t) === actualTotal);
	}

	let isMapView = imageChoice === 1;
	let isMainView = !isMiles || imageChoice === 2;
	let showMapView = isMiles &&
		transaction.accountTransactionId === 0 &&
		isMapView;
	let isSynced = transaction.isExternal;
	let showEnteredBy = user.isHoH && transaction.accountTransactionId !== 0 && transaction.created;
	let showManualImport = fullyImportable.length > 0;
	let showQuickReceipt = isMainView && (receiptEmails?.length ?? 0) > 0;
	let showImageDropdown = isMainView && (showManualImport || showQuickReceipt);
	let showTaxes = FamilyHasAccess(user, Features.Taxes) && !isMiles;
	let ttColor = 'info';

	return (<>
		<ModalHeader Title={`${transaction.accountTransactionId > 0 ? 'Edit' : 'Add'} ${isMiles ? 'Mileage' : FamilyFeatureValue(user, Features.TransactionTitle)}`} CanDelete={props.OnDelete !== undefined} Close={props.Close} Delete={() => props.OnDelete(transaction)} />
		<div className="modal-body">
			<Grid container columnSpacing={1}>
				{showMapView &&
					<MapView OnCalc={UpdateMiles} OnSave={SetMapReceipt} OnCancel={() => setImageChoice(2)} />
				}
				{showEnteredBy && (
					<Grid item xs={12} className="mb-1">Entered by {transaction.created}</Grid>
				)}
				{showReceipt && transaction.receipts.map((receipt: any) => {
					var rowNum = transaction.receipts.indexOf(receipt);
					return (
						<div className="col-12 centered">
							<InnerImageZoom src={`data:image/bmp;base64,${receipt}`} className="img-zoom mb-3" zoomType="hover" height={600} hideHint={true} zoomScale={1} />
							<Button
								className="mb-0"
								component="label"
								variant="text"
								onClick={() => RemoveReceipt(rowNum)}>
								Remove
							</Button>
							<Divider />
						</div>
					);
				})}
				<Grid item xs={12} />
				{isMainView && (
					isMiles ?
						<Amount NoDollar Size={6} Value={transaction.miles} Label="Miles" OnChange={(val: any) => UpdateMiles(val.target.value)} />
					: isSynced ? 
						<Grid item xs={6} style={{ alignSelf: 'center' }}>
							<h4>Total: {USCurrency(total ?? 0)}</h4>
						</Grid>
					:
						<Amount Size={6} Value={total} OnChange={(val: any) => UpdateAmount(val.target.value, -1)} />
				)}
				<Grid item xs={6}>
					{showReceipt ?
						!showImageDropdown ?
							isMainView ?
								(
									<Button
										className="mb-3 right"
										component="label"
										variant="contained"
										startIcon={<CloudUploadFill />}>
										Add Receipt
										<VisuallyHiddenInput type="file" onChange={UploadFile} />
									</Button>
								) :
								<></> :
							(
								<DropdownMenu OpenElement={
									<Button
										className="mb-3"
										component="label"
										variant="contained"
										startIcon={<BoxArrowInUp />}>
										Import
									</Button>
									}
									Items={AddMenuItems() ?? []}
									Open={receiptOpen}
									OnOpen={() => setReceiptOpen(true)}
									OnClose={() => setReceiptOpen(false)}>
								</DropdownMenu>
							) :
						<Button
							className="mb-3 right"
							component="label"
							variant="contained"
							onClick={() => LoadReceipts()}>
							View Receipts
						</Button>
					}
				</Grid>
				{isMainView && <>
					{isMiles ?
						<Grid item xs={12} className="mb-3">
							@{USCurrency(transaction.rate ?? 0)}/mile = {USCurrency((transaction.miles ?? 0) * (transaction.rate ?? 0))}
						</Grid>
						:
						<AutoCompleteMerchant Transactions={allTransactions} Label="Merchant" Value={transaction.merchant} OnChange={UpdateMerchant} Size={12} />
					}
					{showTaxes && <>
						{setTaxes ?
							<Amount Size={6} Value={transaction.rate ?? 0} Label="Taxes" OnChange={(val: any) => UpdateRate(val.target.value)} /> :
							<Grid xs={6} />
						}
						<Toggle Size={6} OnChange={UpdateNoTax} Checked={noTaxes} Label="No Sales Tax?" />
					</>}
					{transaction.allocations.map(budget => {
						var rowNum = transaction.allocations.indexOf(budget);
						return (<>
							{!isMiles && <Divider />}
							<Grid container>
								{budget.isRejected && (
									<Grid item xs={12} className="mb-3 bg-warning" >
										<ExclamationCircleFill className="text-danger mx-3" />
										{budget.approvalNote?.length > 0 && (
											<>
												From {users.find(u => u.userAccountId === budget.reviewerId)?.firstName} {users.find(u => u.userAccountId === budget.reviewerId)?.lastName}: {budget.approvalNote}
											</>
										)}
									</Grid>
								)}
								{budgets.filter(b => b.budgetId === budget.budgetId).length === 0 && budget.budgetId > 0 && <>
									This part of this transaction is assigned to a {budgetLabel.toLowerCase()} that is not available to you on the selected day.
								</>}
								<Dropdown Size={12}
									Class="mb-0"
									Label={budgetLabel + "*"}
									Options={GetBudgetDict()}
									Index={rowNum}
									Value={budget.budgetId}
									OnChange={UpdateBudget} />
								{budgets.find(b => b.budgetId === budget.budgetId)?.subBudgets && budgets.find(b => b.budgetId === budget.budgetId)!.subBudgets!.length > 0 && (<>
									<Dropdown
										Size={12}
										Class="mb-0 mx-3"
										Label={subBudgetLabel + "*"}
										Options={GetSubBudgetDict(budget)}
										Index={rowNum}
										Value={budget.subBudgetId}
										OnChange={UpdateSubBudget}
									/>
								</>)}
								{buckets.map(definition => {
									const options = GetAvailableBucketNodeOptions(bucketNodes, budgets.find(b => b.budgetId === budget.budgetId), definition, transaction.transactionDate, budget);
									const selectedBucketNodeIds = GetAllocationBucketNodeIds(budget, definition.bucketTypeKey);
									const isMultiple = definition.maxSelectionsPerTransaction == null || definition.maxSelectionsPerTransaction > 1;
									const isRequired = definition.minSelectionsPerTransaction != null && definition.minSelectionsPerTransaction > 0;
									const dropdownOptions = [] as SelectableItem[];

									if (!isMultiple) {
										dropdownOptions.push({ Id: 0, Value: `Select ${FamilyBucketLabel(user, definition.bucketTypeKey, definition.label)}` });
									}

									options.forEach(option => dropdownOptions.push({ Id: option.bucketNodeId, Value: option.displayName }));

									return dropdownOptions.filter(d => d.Id !== 0).length > 0 && <Dropdown
										key={`${rowNum}-${definition.bucketTypeKey}`}
										Size={12}
										Class="mb-0"
										Label={FamilyBucketLabel(user, definition.bucketTypeKey, definition.label) + (isMultiple ? ` (Select up to ${definition.maxSelectionsPerTransaction})` : "") + (isRequired ? " *" : "")}
										Options={dropdownOptions}
										Index={rowNum}
										Value={isMultiple ? selectedBucketNodeIds : selectedBucketNodeIds[0] ?? 0}
										Multiple={isMultiple}
										OnChange={(newValue: any, index: number) => UpdateBucketNodes(definition, newValue, index)} />;
								})}
								{transaction.allocations.length > 1 ? (
									<AmountWithTooltip
										Size={5}
										Class="mb-0"
										Tooltip={DisplayBudgetedAmounts(true)}
										TooltipClass={`tooltip-${ttColor}`}
										ArrowClass={`arrow-${ttColor}`}
										Value={budget.amount}
										OnChange={(val: any) => UpdateAmount(val.target.value, rowNum)} />
								) : (<Grid item xs={5} />)}
								{budgets.filter(b => b.budgetId === budget.budgetId).length > 0 && myBudgets.filter(b => b.budgetId === budget.budgetId).length === 0 ? (
									<Dropdown Size={6}
										Class="mb-0 mx-3"
										Label="Select an approver"
										Options={users
											.filter(u => u.isActive && budgets.find(b => b.budgetId === budget.budgetId)?.userIds.includes(u.userAccountId))
											?.map(u => {
												return {
													Id: u.userAccountId,
													Value: `${u.firstName} ${u.lastName}`
												} as SelectableItem;
											})}
										Index={rowNum}
										Value={budget.reviewerId}
										OnChange={UpdateApprover} />
								) : (
									<Grid item xs={6}></Grid>
								)}
								<Description Size={12} Label="Additional Details" Value={budget.details} OnChange={(val: any) => UpdateDetails(val.target.value, rowNum)} />
							</Grid>
						</>);
					})}
					{!isMiles && (
						<Grid container>
							<Grid item xs={6}>
								<Button onClick={AddBudget}>
									Split{transaction.allocations.length > 1 ? " Again" : ""}
								</Button>
							</Grid>
							{transaction.allocations.length > 1 && (
								<Grid item xs={6}>
									<Button onClick={() => RemoveBudget(transaction.allocations.length - 1)}>
										Remove
									</Button>
								</Grid>
							)}
						</Grid>
					)}
					<Divider />
					{transaction.allocations.length > 1 && DisplayBudgetedAmounts()}
					<div className="mb-5"></div>
					{FamilyHasAccess(user, Features.Taxes) && transaction.isExternal &&
						<Grid item xs={12} className="mb-3">
							Account: {accounts.find(a => a.accountId === transaction.accountId)?.description}
						</Grid>
					}
					{!props.Nested && !transaction.isExternal && accounts.filter(a => a.financialInstitution).length > 1 && FamilyHasAccess(user, Features.Taxes) &&
						<Dropdown Size={12}
							Class="mb-0"
							Label="Account"
							Options={GetAccountDict()}
							Value={transaction.accountId}
							OnChange={UpdateAccount} />
					}
					<Date Size={12} Label="Transaction Date" Value={transaction.transactionDate} OnChange={UpdateDate} />
					<Toggle Size={12} OnChange={UpdateIsAdminReview} Checked={transaction.isAdminReview ?? false} Label="Request Review" />
					{FamilyHasAccess(user, Features.Income) && <Toggle Size={12} OnChange={UpdateIsIncome} Checked={transaction.isIncome ?? false} Label="Income" />}
				</>}
				{showQuickReceipt &&
					<ImportQuickReceipt Open={openQuickReceipt} Close={CloseQuickReceipt} Items={receiptEmails} Confirm={ConfirmQuickReceipt} />
				}
				{showManualImport &&
					<ImportManualEntry Open={openImport} Close={CloseImport} FullItems={fullyImportable} ConfirmFull={ConfirmImport} Buckets={buckets} />
				}
			</Grid>
		</div>
		<ModalFooterSaveCancel ShowSave={ShouldShowSave()} Save={Save} Close={props.Close} />
		<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={overlay}>
			<CircularProgress />
		</Backdrop>
	</>);

	//Page Load
	function CurrentBudgets(allBudgets: BudgetItem[]) {
		return allBudgets?.filter(b => !b.activeTimeframes || b.activeTimeframes.length === 0 || b.activeTimeframes.filter(t => (t.startDate?.startOfDay() ?? new DateTime()) < transaction.transactionDate && (!t.endDate || t.endDate!.addDays(1).startOfDay() > transaction.transactionDate)).length > 0) ?? [] as BudgetItem[];
	}
	function ActualTotal(item: TransactionItem) {
		return Math.round(item.allocations.reduce((total, t) => total + (t.amount * 100), 0)) / 100;
	}
	function ShouldShowSave() {
		if (isMiles) {
			if (imageChoice === 2) return true;
			return false;
		}
		if (!transaction.merchant && !transaction.hasReceipt && !transaction.miles) return false;
		if (transaction.allocations.length > 1 && total !== ActualTotal(transaction)) return false;
		if (transaction.allocations.some(allocation => !HasValidAllocation(allocation))) return false;
		return true;
	}
	function HasValidAllocation(allocation: TransactionAllocation) {
		//if (!allocation.budgetId || allocation.budgetId < 1) return false;
		const budget = budgets.find(b => b.budgetId === allocation.budgetId);
		if ((budget?.subBudgets?.length ?? 0) > 0 && !allocation.subBudgetId) return false;
		return HasValidBucketSelections(allocation);
	}
	function HasValidBucketSelections(allocation: TransactionAllocation) {
		return buckets.every(definition => {
			const availableBucketNodeIds = GetAvailableBucketNodeOptions(
				bucketNodes,
				budgets.find(b => b.budgetId === allocation.budgetId),
				definition,
				transaction.transactionDate,
				allocation)
				.map(option => option.bucketNodeId);
			const selectedBucketNodeIds = GetAllocationBucketNodeIds(allocation, definition.bucketTypeKey);
			if (!selectedBucketNodeIds.every(bucketNodeId => availableBucketNodeIds.includes(bucketNodeId))) return false;
			if (availableBucketNodeIds.length === 0) return true;
			return IsAllocationBucketSelectionValid(allocation, definition);
		});
	}
	function AddMenuItems() {
		let result: any[] = [];

		result.push({
			Text: <Button className="mb-3" component="label" variant="text" startIcon={<CloudUploadFill />}>
				Upload Image
				<VisuallyHiddenInput type="file" onChange={UploadFile} />
			</Button>,
			OnClick: () => { }
		});

		if (showQuickReceipt) {
			result.push({
				Icon: <ReceiptCutoff />,
				Text: 'Import Quick Receipt',
				OnClick: QuickReceipt
			});
		}

		if (showManualImport) {
			result.push({
				Icon: <BoxArrowInRight />,
				Text: `Import ${isSynced ? 'Manual' : 'Automatic'} ${FamilyFeatureValue(user, Features.TransactionTitle)}`,
				OnClick: Import
			});
		}

		return result;
	}

	function GetAccountDict() {
		let result: SelectableItem[] = [];
		accounts.forEach(b => result.push({
			Id: b.accountId,
			Value: b.description
		}));
		result.push({
			Id: 0,
			Value: "Cash/Other"
		});
		return result;
	}
	function GetBudgetDict() {
		let result: SelectableItem[] = [];
		result.push({
			Id: -2,
			Value: "Your Budgets"
		});
		myBudgets.forEach(b => result.push({
			Id: b.budgetId,
			Value: b.description
		}));
		result.push({
			Id: -2,
			Value: "Needs Approval"
		});
		budgets
			.filter(b => !b.isMine && b.budgetId > 0 && b.requiresApproval && b.userIds.length > 0)
			.forEach(b => {
				if (users.filter(u => u.isActive && b.userIds.includes(u.userAccountId)).length > 0) {
					result.push({
						Id: b.budgetId,
						Value: b.description
					});
				}
			});
		return result;
	}
	function GetSubBudgetDict(budget: TransactionAllocation) {
		const subBudgets = budgets.find(b => b.budgetId === budget.budgetId)?.subBudgets ?? [];
		return [
			{ Id: 0, Value: `Select ${subBudgetLabel}` },
			...subBudgets.map(sb => ({ Id: sb.subBudgetId, Value: sb.description }))
		];
	}

	//Quick Receipt
	function QuickReceipt() {
		setReceiptOpen(false);
		setOpenQuickReceipt(true);
	}

	function CloseQuickReceipt() {
		setOpenQuickReceipt(false);
	}

	function ConfirmQuickReceipt(selectedReceipt: number) {
		setOpenQuickReceipt(false);
		setTransaction({ ...transaction, hasReceipt: true });
		request
			.get(`ReceiptEmails/Receipt/${selectedReceipt}`)
			.then((receipt: ReceiptEmailItem) => {
				let item = {
					...transaction,
					receipts: [...transaction.receipts].concat(receipt.receipts!),
					editedReceipt: true,
					hasReceipt: true,
					receiptEmailIds: [...transaction.receiptEmailIds ?? [], selectedReceipt]
				};
				setTransaction({
					...item
				});
			});
	}

	//Import Manual
	function Import() {
		setReceiptOpen(false);
		setOpenImport(true);
	}

	function CloseImport() {
		setOpenImport(false);
	}

	function ConfirmImport(linked: TransactionItem) {
		setOverlay(true);
		setOpenImport(false);
		if (!isSynced) {
			let tmp = { ...linked };
			linked = { ...transaction };
			transaction = { ...tmp };
		}
		linked = { ...linked };
		let item = {
			...transaction,
			allocations: [...linked.allocations],
			hasReceipt: linked.hasReceipt || transaction.hasReceipt,
			needsReimbursement: linked.needsReimbursement,
			isAdminReview: linked.isAdminReview,
			transactionDate: linked.transactionDate,
			importedTransactionId: linked.accountTransactionId
		};
		setTransaction({ ...item });
		if (linked.hasReceipt) {
			request
				.get(`Transactions/Receipt/${linked.accountTransactionId}`)
				.then((receipt: TransactionItem) => {
					item = {
						...item,
						receipts: [...item.receipts].concat(receipt.receipts),
						editedReceipt: true
					};
					setTransaction({
						...item
					});
					setOverlay(false);
				});
		} else {
			setOverlay(false);
		}
	}

	//Edit Fields
	function UpdateMerchant(event: any, newValue: string) {
		var item = ({ ...transaction, merchant: newValue });
		setTransaction(item);
	}
	function AddBudget() {
		if (transaction.allocations.length === 1 && transaction.allocations[0].amount === total) {
			let bcas = [] as TransactionAllocation[];
			bcas.push({ ...transaction.allocations[0], amount: 0 });
			transaction = { ...transaction, allocations: bcas };
		}

		let bca: TransactionAllocation[] = [...(transaction.allocations)];
		bca.push(CreateBudgetAllocation(undefined, 0));
		let item = ({ ...transaction, allocations: bca });
		setTransaction(item);
	}
	function UpdateBudget(newValue: any, index: number) {
		if (!index) index = 0;
		let bca: TransactionAllocation[] = [];
		transaction.allocations.forEach(budget => {
			if (transaction.allocations.indexOf(budget) === index) {
				let reviewerId: number | null = null;
				if (myBudgets.filter(b => b.budgetId === newValue).length === 0) {
					reviewerId = budget.reviewerId;
					let budgetUsers = users
						.filter(u => u.isActive && budgets.find(b => b.budgetId === newValue)?.userIds.includes(u.userAccountId));
					if (budgetUsers.length > 0 && budgetUsers.filter(b => b.userAccountId === (reviewerId ?? 0)).length === 0) {
						reviewerId = budgetUsers[0].userAccountId;
					}
				}
				bca.push(CreateBudgetAllocation(
					budgets.find(b => b.budgetId === newValue),
					budget.amount,
					{ ...budget, reviewerId }
				));
			} else {
				bca.push({ ...budget });
			}
		})
		let item = ({ ...transaction, allocations: bca });
		setTransaction(item);
	}
	function RemoveBudget(idx: number) {
		let bca: TransactionAllocation[] = [...(transaction.allocations)];
		bca.splice(idx, 1);
		let item = ({ ...transaction, allocations: bca });
		setTransaction(item);
	}
	function UpdateSubBudget(newValue: number, index: number) {
		if (!index) index = 0;
		let bca: TransactionAllocation[] = [];
		transaction.allocations.forEach(budget => {
			if (transaction.allocations.indexOf(budget) === index) {
				bca.push({ ...budget, subBudgetId: newValue });
			} else {
				bca.push({ ...budget });
			}
		})
		let item = ({ ...transaction, allocations: bca });
		setTransaction(item);
	}
	function UpdateBucketNodes(definition: BucketTypeDefinitionItem, newValue: any, index: number) {
		if (!index) index = 0;
		let bca: TransactionAllocation[] = [];
		transaction.allocations.forEach(budget => {
			if (transaction.allocations.indexOf(budget) === index) {
				const options = GetAvailableBucketNodeOptions(bucketNodes, budgets.find(b => b.budgetId === budget.budgetId), definition, transaction.transactionDate, budget);
				let bucketNodeIds = Array.isArray(newValue) ? newValue : [newValue];
				bucketNodeIds = bucketNodeIds.filter((bucketNodeId: number) => bucketNodeId > 0 && options.some(option => option.bucketNodeId === bucketNodeId));
				if (definition.maxSelectionsPerTransaction != null) {
					bucketNodeIds = bucketNodeIds.slice(0, definition.maxSelectionsPerTransaction);
				}
				let next = UpdateAllocationBucketNodeIds(budget, definition.bucketTypeKey, bucketNodeIds, options);
				next = RevalidateAllocationBucketNodes(next, budgets.find(b => b.budgetId === next.budgetId), buckets, bucketNodes, transaction.transactionDate);
				bca.push(next);
			} else {
				bca.push({ ...budget });
			}
		})
		let item = ({ ...transaction, allocations: bca });
		setTransaction(item);
	}
	function UpdateApprover(newValue: any, index: number) {
		if (!index) index = 0;
		let bca: TransactionAllocation[] = [];
		transaction.allocations.forEach(budget => {
			if (transaction.allocations.indexOf(budget) === index) {
				bca.push({ ...budget, reviewerId: newValue });
			} else {
				bca.push({ ...budget });
			}
		})
		let item = ({ ...transaction, allocations: bca });
		setTransaction(item);
	}
	function UpdateAccount(newValue: any) {
		let item = ({ ...transaction, accountId: newValue });
		setTransaction(item);
	}
	function UpdateDate(newValue: any) {
		let item = ({ ...transaction, transactionDate: new DateTime(newValue) });
		setTransaction(item);
	}
	function UpdateMiles(newValue: string) {
		let val: number | null = null;
		if (newValue) val = parseFloat(newValue);
		let item = ({ ...transaction, miles: val, merchant: `Mileage: ${val} miles` });
		setTransaction(item);
	}
	function UpdateRate(newValue: string) {
		let val: number | null = null;
		if (newValue) val = parseFloat(newValue);
		if (val === 0) val = null;
		let item = ({ ...transaction, rate: val });
		setTransaction(item);
	}
	function UpdateAmount(newValue: string, index: number) {
		let val = 0;
		if (newValue) {
			val = parseFloat(newValue);
			if (isNaN(val)) {
				setTransaction({ ...transaction });
				return;
			}
		}
		if (index === -1) {
			setTotal(val);
		}
		if (index > -1) {
			let amounts = [] as TransactionAllocation[];
			for (let i in transaction.allocations) {
				let amount = transaction.allocations[i].amount;
				if (parseInt(i) === index) {
					amount = val;
				}
				amounts.push({ ...transaction.allocations[i], amount: amount });
			}
			let item = { ...transaction, allocations: amounts };
			setTransaction(item);
		}
	}
	function UpdateDetails(newValue: string, index: number) {
		if (!index) index = 0;
		let bca: TransactionAllocation[] = [];
		transaction.allocations.forEach(budget => {
			if (transaction.allocations.indexOf(budget) === index) {
				bca.push({ ...budget, details: newValue });
			} else {
				bca.push({ ...budget });
			}
		})
		let item = ({ ...transaction, allocations: bca });
		setTransaction(item);
	}
	function CreateBudgetAllocation(budget: BudgetItem | undefined, amount: number, sourceAllocation?: TransactionAllocation) {
		const sourceSubBudgetId = sourceAllocation?.subBudgetId;
		const subBudgetId = budget?.subBudgets?.some(sb => sb.subBudgetId === sourceSubBudgetId) ? sourceSubBudgetId : undefined;
		let allocation = {
			amount,
			approvalNote: sourceAllocation?.approvalNote ?? "",
			budgetId: budget?.budgetId ?? 0,
			subBudgetId,
			bucketNodes: [],
			details: sourceAllocation?.details,
			isApproved: sourceAllocation?.isApproved ?? false,
			isRejected: sourceAllocation?.isRejected ?? false,
			reviewerId: sourceAllocation?.reviewerId ?? null,
		} as TransactionAllocation;

		buckets.forEach(definition => {
			const options = GetAvailableBucketNodeOptions(bucketNodes, budget, definition, transaction.transactionDate, allocation);
			let bucketNodeIds = GetAllocationBucketNodeIds(sourceAllocation, definition.bucketTypeKey)
				.filter(bucketNodeId => options.some(option => option.bucketNodeId === bucketNodeId));
			if (definition.maxSelectionsPerTransaction != null) {
				bucketNodeIds = bucketNodeIds.slice(0, definition.maxSelectionsPerTransaction);
			}
			allocation = UpdateAllocationBucketNodeIds(allocation, definition.bucketTypeKey, bucketNodeIds, options);
		});

		return allocation;
	}
	function UpdateIsAdminReview(event: any, newValue: boolean) {
		let item = ({ ...transaction, isAdminReview: newValue });
		setTransaction(item);
	}
	function UpdateIsIncome(event: any, newValue: boolean) {
		let item = ({ ...transaction, isIncome: newValue });
		setTransaction(item);
	}
	function UpdateNoTax(event: any, newValue: boolean) {
		if (newValue) {
			let item = ({ ...transaction, rate: 0 });
			setTransaction(item);
		} else {
			let item = ({ ...transaction, rate: null });
			setTransaction(item);
		}
		setNoTaxes(newValue);
		setSetTaxes(!newValue);
	}

	//Images
	async function UploadFile(event: React.ChangeEvent<HTMLInputElement>) {
		setReceiptOpen(false);
		let { files } = event.target;
		let file = (files as FileList)[0];
		if (file.type.startsWith("image")) {
			let resizedFile = await new Promise(resolve =>
				FileResizer.imageFileResizer(file, 1280, 1280, file.type.replace("image/", ""), 100, 0, uri => resolve(uri))
			);
			let item = {
				...transaction,
				receipts: [...transaction.receipts, resizedFile!.toString().substring(resizedFile!.toString().indexOf(',') + 1)],
				editedReceipt: true,
				hasReceipt: true,
				receiptEmailIds: undefined
			};
			setTransaction(item);
		} else {
			let data = await ReadFileData(file);
			let pdfjs = await PDFJS;
			let pdfPromise = await pdfjs.getDocument(data).promise;
			
			var pdf = await pdfPromise;
			iterate(pdf, 1);
		}
	}
	async function iterate(pdf: any, currentPage: number = 1) {
		var pages: any[] = [];
		if (currentPage <= pdf.numPages) pages = await getPage(pdf, currentPage, pages);

		if (pages.length > 0) {
			let item = {
				...transaction,
				receipts: [...transaction.receipts].concat(pages.map((final: any) => final!.toString().substring(final.toString().indexOf(',') + 1))),
				editedReceipt: true,
				hasReceipt: true,
				receiptEmailIds: undefined
			};
			setTransaction(item);
		}
	}
	async function getPage(pdf: any, currentPage: number, pages: any[]): Promise<any[]> {
		var deferred: Deferred<any[]> = Q.defer();

		var canvas = document.createElement('canvas');
		let page = await pdf.getPage(currentPage);
		let viewport = page.getViewport({ scale: 3 });
		let context = canvas.getContext("2d");
		canvas.height = viewport.height;
		canvas.width = viewport.width;
		await page.render({ canvasContext: context, viewport: viewport }).promise;

		await canvas.toBlob(async (result) => {
			var resizedFile: any = await new Promise(resolve =>
				FileResizer.imageFileResizer(result!, 1280, 6400, 'jpg', 100, 0, uri => resolve(uri))
			);
			pages.push(resizedFile);

			if (currentPage < pdf.numPages) {
				currentPage++;
				pages = await getPage(pdf, currentPage, pages);
			}
			deferred.resolve(pages);
		});

		return deferred.promise;
	}
	function ReadFileData(file: File) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = (e) => {
				resolve(e.target!.result);
			};
			reader.onerror = (err) => {
				reject(err);
			};
			reader.readAsDataURL(file);
		});
	}

	function SetMapReceipt(file: string) {
		let t = {
			...transaction,
			receipts: [file],
			receiptString: '',
			receiptItem: null,
			hasReceipt: true,
			editedReceipt: true
		}
		setTransaction(t);
		setImageChoice(2);
	}

	function LoadReceipts(attach: boolean = false) {
		if (transaction.accountTransactionId === 0) {
			setShowReceipt(true);
			return;
		}
		setOverlay(true);
		request
			.get(`Transactions/Receipt/${transaction.accountTransactionId}`)
			.then((receipt: TransactionItem) => {
				let rec = receipt.receipts;
				if (attach) {
					for (let i in props.AttachedReceipt.receipts)
					rec.push(props.AttachedReceipt.receipts[i]);
				}
				let item = {
					...transaction,
					receipts: receipt.receipts,
					receiptEmailIds: attach ? [...[], props.AttachedReceipt!.receiptEmailId] : undefined,
					hasReceipt: true,
					editedReceipt: true
				};
				setTransaction({
					...item
				});
				setOverlay(false);
				setShowReceipt(true);
			});
	}

	function RemoveReceipt(idx: number) {
		let rct: string[] = [...(transaction.receipts)];
		rct.splice(idx, 1);
		let item = ({ ...transaction, receipts: rct, editedReceipt: true, hasReceipt: rct.length > 0, receiptEmailIds: ((transaction.receiptEmailIds?.length ?? 0) > rct.length) ? undefined : transaction.receiptEmailIds });
		setTransaction(item);
	}

	//Budget Split
	function DisplayBudgetedAmounts(isTooltip: boolean = false) {
		if (actualTotal === total) {
			let text = `All ${USCurrency(total ?? 0)} Budgeted!`;
			if (isTooltip) {
				ttColor = 'success';
				return text;
			}
			return (<>
				<Grid item className="text-success mx-3">
					{text}
				</Grid>
				<Divider />
			</>);
		} else if ((actualTotal ?? 0) > (total ?? 0)) {
			let text = `Budgeted ${USCurrency((actualTotal ?? 0) - (total ?? 0))} over total amount of ${USCurrency(total ?? 0)}`;
			if (isTooltip) {
				ttColor = 'error';
				return text;
			}
			return (<>
				<Grid item className="text-danger mx-3">
					{text}					
				</Grid>
				<Divider />
			</>);
		} else {
			let text = `${USCurrency((total ?? 0) - (actualTotal ?? 0))} of ${USCurrency(total ?? 0)} remaining`;
			if (isTooltip) {
				ttColor = 'info';
				return text;
			}
			return (<>
				<Grid item className="text-app mb-3 mx-3" xs={12}>
					{text}
				</Grid>
				<Button className="mb-1 mx-1 right" component="label" variant="contained" startIcon={<ReceiptCutoff />} onClick={SplitEvenly}>
					Split Remainder Evenly
				</Button>
				<Button className="mb-1 mx-1 right" component="label" variant="contained" startIcon={<ReceiptCutoff />} onClick={SplitProportionally}>
					Split Remainder Proportionally
				</Button>
				<Divider />
			</>);
		}
	}
	function SplitEvenly() {
		let dif = (total ?? 0) - (actualTotal ?? 0);
		let amounts = [] as TransactionAllocation[];
		for (let i in transaction.allocations) {
			let amount = transaction.allocations[i].amount ?? 0;
			let perc = 1 / transaction.allocations.length;

			if (parseInt(i) === transaction.allocations.length - 1) {
				let leftover = (total ?? 0) - amounts.reduce((tot, t) => tot + t.amount, 0)
				amount = leftover;
			} else {
				amount += dif * perc;
			}

			amount = Math.round(amount * 100) / 100;
			amounts.push({ ...transaction.allocations[i], amount: amount });
		}
		let item = { ...transaction, allocations: amounts };
		setTransaction(item);
	}
	function SplitProportionally() {
		if (!actualTotal) SplitEvenly();

		let dif = (total ?? 0) - (actualTotal ?? 0);
		let amounts = [] as TransactionAllocation[];
		for (let i in transaction.allocations) {
			let amount = transaction.allocations[i].amount ?? 0;
			let perc = amount / actualTotal!;

			if (parseInt(i) === transaction.allocations.length - 1) {
				let leftover = (total ?? 0) - amounts.reduce((tot, t) => tot + t.amount, 0)
				amount = leftover;
			} else {
				amount += dif * perc;
			}

			amount = Math.round(amount * 100) / 100;
			amounts.push({ ...transaction.allocations[i], amount: amount });
		}
		let item = { ...transaction, allocations: amounts };
		setTransaction(item);
	}

	function Save() {
		if (transaction.allocations.length === 1 && transaction.allocations[0].amount !== total) {
			let bcas = [] as TransactionAllocation[];
			bcas.push({ ...transaction.allocations[0], amount: total ?? 0 });
			transaction = { ...transaction, allocations: bcas, rate: (!showTaxes || setTaxes) ? transaction.rate : null };
		}
		props.OnSave(transaction);
	}
}


export default EditTransaction;